module.exports = __webpack_public_path__ + "assets/head.svg";